export default __webpack_public_path__ + "static/media/04.da8a9ed9.jpg";